import React, { useContext, useEffect, useState } from "react";
import { Table, Tag, Space, Button, Row, Col } from "antd";
import _ from "lodash";
// import { ImageViewer } from "react-image-viewer-dv";
import { LanguageContext } from "../../context/LanguageContext";
import { ImageViewOnly } from "../image/onlyImageVIew";
import moment from "moment";

export const AropiInfoTable = (props) => {
  const [tblData, SetTblData] = useState([]);
  const { t } = useContext(LanguageContext);
  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [id, setId] = useState();

  const openImageModal = (img, id) => {
    setImageOpen(true);
    setSelectedImage(img);
    setId(id);
  };

  const closeImageModal = () => {
    setImageOpen(false);
    setSelectedImage(null);
  };

  const handleViewForm = (data) => {
    props?.onViewAccusedForm(data);
  };

  console.log("loading", props.loading);
  const columns = [
    {
      title: t("sr.no"),
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) => <Space size="middle">{index + 1}</Space>,
    },
    {
      title: "आरोपीचे पो. स्टे",
      dataIndex: "crime_districtName",
      key: "crime_districtName",
      render: (text, record) => (
        <Space size="middle">
          {record?.crime_districtName || record?.districtName}
        </Space>
      ),
    },
    {
      title: t("name"),
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Space
          size="middle"
          title={record.masterId ? record?.masterId : record.id}
        >
          {record?.name}
        </Space>
      ),
    },

    {
      title: t("total_crimes"),
      dataIndex: "totalCrimeCount",
      key: "totalCrimeCount",
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            shape="circle"
            size="small"
            style={{
              width: 36,
              height: 36,
              fontWeight: 600,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            }}
            onClick={() => props.onViewAccusedForm(record.masterId)}
          >
            {record.totalCrimeCount}
          </Button>
        </div>
      ),
    },
    {
      title: "शेवटचा गुन्ह्याचे पो. स्टे ",
      dataIndex: "last_districtName",
      key: "last_districtName",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record?.last_districtName}
        </Space>
      ),
    },

    {
      title: "CR.No/DateTime",
      dataIndex: "cr_no",
      key: "cr_no",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {`${text ? text : "-"} / ${
            record.guna_date ? record.guna_date : "-"
          }`}
        </Space>
      ),
    },

    {
      ...{
        title: t("photo"),
        key: "photos",
        render: (text, record) => (
          <Space size="middle">
            {record.photos ? (
              // <ImageViewer>
              <img
                style={{ width: 50, height: 50 }}
                src={
                  "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                  record.photos
                }
                onClick={() => openImageModal(record.photos, record.id)}
              ></img>
            ) : (
              // </ImageViewer>
              t("no")
            )}
          </Space>
        ),
      },
    },
    {
      ...{
        title: t("action"),
        key: "action",
        render: (text, record) => (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                handleViewForm(record.masterId ? record?.masterId : record.id);
              }}
            >
              {t("view1")}
            </Button>
          </div>
        ),
      },
    },
  ];
  const columns1 = [
    {
      title: t("sr.no"),
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) => <Space size="middle">{index + 1}</Space>,
    },
    {
      title: "आरोपीचे पो. स्टे",
      dataIndex: "crime_districtName",
      key: "crime_districtName",
      render: (text, record) => (
        <Space size="middle">
          {record?.crime_districtName || record?.districtName}
        </Space>
      ),
    },
    {
      title: t("name"),
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Space
          size="middle"
          title={record.masterId ? record?.masterId : record.id}
        >
          {record?.name}
        </Space>
      ),
    },

    {
      title: t("total_crimes"),
      dataIndex: "totalCrimeCount",
      key: "totalCrimeCount",
      render: (text, record) => (
        <Space size="middle" style={{ maxWidth: 300 }}>
          {record?.totalCrimeCount}
        </Space>
      ),
    },

    {
      ...{
        title: t("photo"),
        key: "photos",
        render: (text, record) => (
          <Space size="middle">
            {record.photos ? (
              // <ImageViewer>
              <img
                style={{ width: 50, height: 50 }}
                src={
                  "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                  record.photos
                }
                onClick={() => openImageModal(record.photos, record.id)}
              ></img>
            ) : (
              // </ImageViewer>
              t("no")
            )}
          </Space>
        ),
      },
    },
    {
      ...{
        title: t("action"),
        key: "action",
        render: (text, record) => (
          <div className="action-links-responsive">
            <Button
              type="text"
              size="small"
              className="action-link update-link"
              onClick={() => {
                handleViewForm(record.masterId ? record?.masterId : record.id);
              }}
            >
              {t("view1")}
            </Button>
          </div>
        ),
      },
    },
  ];

  useEffect(() => {
    let tempData = [];

    tempData =
      props.criminalList &&
      props.criminalList.map((res, index) => {
        return {
          ...res,
          key: index + 1,
        };
      });
    SetTblData(tempData);
  }, [props.criminalList]);
  console.log("imageOpen", imageOpen);
  return (
    <>
      <Table
        columns={props.show === true ? columns : columns1}
        dataSource={tblData}
        loading={props.loading}
      />
      {imageOpen && (
        <ImageViewOnly
          imageOpen={imageOpen}
          imageUrl={
            "https://pcimageupload.s3.ap-south-1.amazonaws.com/" + selectedImage
          }
          onClose={closeImageModal}
          id={id}
        />
      )}
    </>
  );
};
